import React from 'react';
import WeaWfFinancial from './cell-field/input-element/wf-financial';
import { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import { observer } from 'mobx-react';
import { WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
export interface ExcelTableCellLabelProps {
    cell: CellProps;
    card: CardStore;
    [key: string]: any;
}

@observer
export default class ExcelTableCellLabel extends React.Component<ExcelTableCellLabelProps, any> {
    constructor(props) {
        super(props);
        const { cell, card } = props;
        const path = cell.getPath();
        const { order } = card.getFieldProps(path);
        this.state = {
            orderbytype: order
        }
    }
    /***
     * #446018
        概述：解决了导航树，是否刷新左侧树在前端菜单中使用不生效，后端预览正常的问题
        这个qc加的但是好像没啥关系， 不知道啥问题。，先关闭了吧
     */
    // componentDidMount(){
    //     setTimeout(()=>{this.forceUpdate();},1000)
    // }

    render() {
        const { cell, card, form } = this.props;
        const path = cell.getPath();
        let { fieldlabel: label, isdetail, order, detail } = card.getFieldProps(path);
        let isOpenCustomOrder = false;
        if (isdetail) {
            const excel = card.modeExcel.getExcel(detail);
            const { isPagination = false } = excel.detailProps;
            const isNeedPagination = (card.base.type == '0' || card.base.type == '1' || card.base.type == '2') && isPagination;
            let detailtable = card.getDetailTable(detail);
            isOpenCustomOrder = detailtable.isOpenCustomOrder && !isNeedPagination;
        }
        let title = isOpenCustomOrder ? getLabel('514223', '已启用拖动排序，字段排序失效！') : '';
        let style = isOpenCustomOrder ? { color: '#BDBDBD' } : {};
        const { financial } = cell;
        if (financial && financial.indexOf("1-") > -1) {     //财务表头
            const finaNum = parseInt(financial.split("-")[1] || "3");
            return <WeaWfFinancial type={1} finNum={finaNum} label={label} className={"cube-financial-th"} />
        }
        if (!label) { // 标签不设置对应的值，在store中无法取到标签，此时直接在cell中获取
            label = cell.evalue;
        }
        if (!isdetail && isdetail != undefined) { //如果是非明细表，viewattr=4的时候也隐藏label
            const bindObj = form.has(path) ? form.$(path) : {};
            const { viewAttr } = bindObj.bind();
            if (viewAttr == '4') {
                return (
                    <div {...cell.cellProps} className="card-table-th-break" >

                    </div>
                )
            }
        }
        return (
            <div {...cell.cellProps} className="card-table-th-break" onClick={(isdetail && !isOpenCustomOrder && typeof order == 'boolean') ? this.handleLabelClick : undefined}>
                {label}
                {
                    typeof order == 'boolean' && <span className="sort-icon">
                        <span title={title} style={style} className={this.state.orderbytype ? 'icon-coms-positive-sequence' : 'icon-coms-Reverse'} />
                    </span>
                }
            </div>
        )
    }
    handleLabelClick = () => {
        const { cell, card } = this.props;
        const path = cell.getPath();
        const order = !this.state.orderbytype;
        this.setState({
            orderbytype: order
        })
        card.refreshDetail(path, order);
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/CellLabel.tsx